import classNames from "classnames";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import useScrollLock from "@repo/shopifyV2/hooks/useScrollLock";

import Button from "@atoms/Button";
import Link from "@atoms/Link";

import HeaderSearch from "@organisms/Header/HeaderSearch";

import { URLS } from "@const/urls";

import useCheckLocation from "@hooks/useCheckLocation";
import useLanguage from "@hooks/useLanguage";

import { useCustomerStore } from "@store/customer";
import { useLayoutStore } from "@store/layout";

export default function HeaderMenu() {
  const navigate = useNavigate();
  const { lang, market } = useLanguage();

  const { token, caaToken } = useCustomerStore();

  const hasCustomerSession = lang === "jp" ? Boolean(caaToken?.accessToken) : Boolean(token.accessToken);

  const { pathname } = useLocation();

  const { isOpenAccount, openAccount, isOpenMarket, openMarket, openNavigation, isOpenNavigation, closeAll } = useLayoutStore();

  const { isDanielJohnston } = useCheckLocation();

  useScrollLock();

  return (
    <div
      className={classNames(
        "pc:pt-0 pc:h-[calc(100dvh-4.75rem)] fixed top-13.5 left-0 z-60 flex h-dvh w-full flex-col gap-10 bg-white px-4 pt-4 dark:text-white",
        isDanielJohnston ? "dark:bg-dj-black" : "dark:bg-black",
      )}
    >
      <HeaderSearch />
      <div className="flex flex-col gap-2.5">
        <Button
          as="text"
          className="text-title!"
          onClick={() => {
            openNavigation(!isOpenNavigation);
          }}
        >
          Shop
        </Button>
        <Link as="text" className="text-title" href={URLS.FEATURES}>
          Features
        </Link>
      </div>
      <div className="flex flex-col gap-2.5">
        <Link as="text" className="text-title" href={URLS.INFORMATION_CONTACT}>
          Information
        </Link>
        <Link as="text" className="text-title" href={URLS.STORES}>
          Stores
        </Link>
      </div>
      <div className="flex flex-col gap-2.5">
        <Button
          className="text-title"
          onClick={() => {
            if (pathname.replaceAll("/", "") === URLS.ORDER_HISTORY.replaceAll("/", "")) {
              window.scrollTo(0, 0);
              closeAll();
            }

            if (hasCustomerSession) navigate(URLS.ORDER_HISTORY);
            else openAccount(!isOpenAccount);
          }}
        >
          Account
        </Button>
        <Button
          className="text-title"
          onClick={() => {
            openMarket(!isOpenMarket);
          }}
        >
          {market}
        </Button>
      </div>
    </div>
  );
}
